import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { MbCheckoutContactDetailsModel } from '../../../models'

export const MB_CHECKOUT_CONTACT_DETAILS_NORMALIZER = new InjectionToken<Converter<any, MbCheckoutContactDetailsModel>>('MbCheckoutContactDetailsNormalizer')
